import { projectsNotFoundRoute } from '@jira/router-routes__projects-not-found-routes/src/projectsNotFoundRoute.tsx';
import { projectNotFoundEntryPoint } from '@jira/spa-apps__project-not-found/src/projectNotFoundEntryPoint.entrypoint.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import type { Route } from '@atlassian/react-resource-router';

const projectsNotFoundPageEntryPoint = createPageEntryPoint({
	main: projectNotFoundEntryPoint,
});

export const projectsNotFoundRouteEntry: Route = createEntry(projectsNotFoundRoute, () => ({
	group: 'errors',
	entryPoint: () => projectsNotFoundPageEntryPoint,
	layout: globalLayout,
	resources: [...getNavigationResources()],
	pageId: 'projects-not-found-page-id',
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
